export default "__VITE_ASSET__Bt4F8wA3__"